import React, { useMemo } from 'react';
import { Div, Pagination } from '@gaiads/telia-react-component-library';
import { PageMetadata } from '@cdaas/api-clients/dist/product-service-openapi';

import { calculatePaginationValues } from '../../utils/ui';

interface ListPaginationProps {
  pageMetadata: PageMetadata;
  showText: string;
  numberOfItemsPerPageOptions: number[];
  currentPageNumber: number;
  onPageNumberChange: (pageNumber: number) => void;
  numberOfItems: number;
  onNumberOfItemsChange: (numberOfItems: number) => void;
}

export function ListPagination({
  pageMetadata,
  showText,
  numberOfItemsPerPageOptions,
  currentPageNumber,
  onPageNumberChange,
  numberOfItems,
  onNumberOfItemsChange,
}: ListPaginationProps) {
  const lastPageNumber = pageMetadata.total_pages < 1 ? 1 : pageMetadata.total_pages;

  const pageSelectorProps = useMemo(
    () => calculatePaginationValues(pageMetadata.total_items, currentPageNumber + 1, numberOfItems, lastPageNumber),
    [pageMetadata, currentPageNumber, numberOfItems, lastPageNumber],
  );

  /* Pagination event handlers */

  const goToPageNumber = (pageNumber: number) => {
    const newPageNumber = pageNumber - 1; // page number start from 0 on backend
    if (newPageNumber !== currentPageNumber) {
      onPageNumberChange(newPageNumber);
    }
  };

  const goToNextPage = () => {
    if (currentPageNumber + 1 < pageMetadata.total_pages) {
      const nextPageNumber = currentPageNumber + 1;
      onPageNumberChange(nextPageNumber);
    }
  };

  const goToPreviousPage = () => {
    if (currentPageNumber > 0) {
      const previousPageNumber = currentPageNumber - 1;
      onPageNumberChange(previousPageNumber);
    }
  };

  const handleSetNumberOfItems = (size: number) => {
    onNumberOfItemsChange(size);
  };

  return (
    <Div>
      <Pagination centered spaceBetween pileVerticallyTo={'md'}>
        <Pagination.ItemsPerPage
          showText={showText}
          numberOfItemsEachPageOptions={numberOfItemsPerPageOptions}
          setNumberOfItems={handleSetNumberOfItems}
          numberOfItemsEachPage={numberOfItems}
        />
        <Pagination.PageSelector
          goToPageNumber={goToPageNumber}
          goToNextPage={goToNextPage}
          goToPreviousPage={goToPreviousPage}
          alignRight
          centered
          {...pageSelectorProps}
        />
      </Pagination>
    </Div>
  );
}
